import { jsx as v } from "react/jsx-runtime";
import c from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as l } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
const h = c.div`
  box-sizing: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContainer.boxSizing;
}};
  display: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContainer.display;
}};
  justify-content: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContainer.justifyContent;
}};
  align-items: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContainer.alignItems;
}};
  height: ${({ $size: a, ...t }) => {
  var e;
  return (e = t == null ? void 0 : t.theme) == null ? void 0 : e.components.avatar.AvatarContainer.height[a || "default"];
}};
  width: ${({ $size: a, ...t }) => {
  var e;
  return (e = t == null ? void 0 : t.theme) == null ? void 0 : e.components.avatar.AvatarContainer.width[a || "default"];
}};
  border-radius: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContainer.borderRadius;
}};
  text-align: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContainer.textAlign;
}};
  background-color: ${({ $type: a, ...t }) => {
  var e;
  return (e = t == null ? void 0 : t.theme) == null ? void 0 : e.components.avatar.AvatarContainer.backgroundColor[a || "default"];
}};
`, u = c.span`
  display: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContent.display;
}};
  box-sizing: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContent.boxSizing;
}};
  justify-content: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContent.justifyContent;
}};
  align-items: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContent.alignItems;
}};
  ${({ $size: a, ...t }) => {
  var e, n, i, m;
  switch (a) {
    case "large":
      return (e = t == null ? void 0 : t.theme) == null ? void 0 : e.components.avatar.AvatarContent.textSize.large;
    case "small":
      return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.avatar.AvatarContent.textSize.small;
    case "extraSmall":
      return (i = t == null ? void 0 : t.theme) == null ? void 0 : i.components.avatar.AvatarContent.textSize.extraSmall;
    case "medium":
    default:
      return (m = t == null ? void 0 : t.theme) == null ? void 0 : m.components.avatar.AvatarContent.textSize.medium;
  }
}}
  color: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContent.color;
}};
  text-align: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContent.textAlign;
}};
  font-style: ${(a) => {
  var t;
  return (t = a == null ? void 0 : a.theme) == null ? void 0 : t.components.avatar.AvatarContent.fontStyle;
}};
`;
function f({ size: a = "medium", type: t = "primary", ...e }) {
  const n = l({ label: "Avatar" });
  return /* @__PURE__ */ v(
    h,
    {
      $size: a,
      $type: t,
      ...e,
      ...n,
      children: /* @__PURE__ */ v(
        u,
        {
          role: "content",
          $size: a,
          ...e,
          children: e.initials
        }
      )
    }
  );
}
export {
  f as AvatarNew
};
